import { useStepperStore } from '@store/stepperStore';
import { ReactElement } from 'react';
import { AddNewSite, SiteAddress, TaskList, VisitRecord, AddNewMicroSite } from './components';
import { SUPERVISOR_ALLOWED_CLASS } from '@config/constant';
import useSiteLeadStore from '@store/siteLeadStore';
import { useComponentLevelAccessCheck } from '../../authGuard/hooks/useComponentLevelAccessCheck';

export const SiteLeads = (): ReactElement => {
	const { currentStep } = useStepperStore();
	const { siteDetails } = useSiteLeadStore();
	const isKAEGlueFields = useComponentLevelAccessCheck('kae-glue-fields');
	const isLC = isKAEGlueFields && SUPERVISOR_ALLOWED_CLASS.includes(siteDetails?.contractorclass || '');
	return (
		<>
			{currentStep === 0 && <AddNewSite />}
			{currentStep === 1 && <TaskList />}
			{currentStep === 2 && <SiteAddress />}
			{currentStep === 3 && isLC && <AddNewMicroSite />}
			{currentStep === 3 && !isLC && <VisitRecord />}
			{currentStep === 4 && isLC && <VisitRecord />}
		</>
	);
};
